import { PauseCircle } from 'lucide-react';

interface SeatPausedNoticeProps {
  productLabel: string;
  /** Whether the org's underlying Stripe status is 'past_due' — names the cause when known. */
  isPastDue: boolean;
}

/**
 * Full-screen block shown in place of the app when the signed-in user's own seat is paused —
 * assigned, but over the plan's current cap (see `sortSeatsByPrecedence` on the backend). Mounted
 * by `WorkspaceLayout` in place of the route tree, the one choke point every route already shares,
 * so this replaces what would otherwise be every individual content query 403ing independently
 * with no unified explanation.
 */
export function SeatPausedNotice({ productLabel, isPastDue }: SeatPausedNoticeProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-6 text-foreground">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
          <PauseCircle className="h-6 w-6 text-destructive" />
        </div>
        <h1 className="mb-2 text-xl font-bold tracking-tight">Your seat is paused</h1>
        <p className="mb-2 text-sm text-muted-foreground">
          Your seat is paused because the organization has more assigned {productLabel} seats than
          its plan allows. Ask an admin to subscribe or free a seat under Members.
        </p>
        {isPastDue && (
          <p className="text-sm text-muted-foreground">
            This happened because a recent payment failed and the organization was moved to the Free
            plan.
          </p>
        )}
      </div>
    </div>
  );
}
